/**
 * Given two selects:
 * 
 *  <select id="family">
 * 	  <option value="1">Feline</option>
 * 	  <option value="2">Canine</option>
 *  </select>
 * 
 *  <select id="name">
 * 	  <optgroup forFamily="1" label="Feline">
 * 	    <option value="1">Cat</option>
 * 	    <option value="2">Lion</option>
 *    </optgroup>
 *    <optgroup forFamily="2" label="Canine">
 *      <option value="3">Dog</option>
 *      <option value="4">Wolf</option>
 *    </optgroup>
 *  </select>
 *  
 *  
 * Calling:
 *  $('#name').sequentalSelect({
 *  	parent: $('#family'),
 *  	optgroupAttr: 'forFamily'
 *  });
 *  
 * Will dynamically filter the options in the select, showing only
 *  those options whose optgroup's attr equals the parent selector's
 *  value, removing all other options.
 *  
 *  
 * For example, if $('#family').val() == 1, the #name select will be:
 *  
 *  <select id="name">
 *    <option value="1" selected="selected">Cat</option>
 *    <option value="2">Lion</option>
 *  </select>
 *  
 *  (automatically reselects first option)
 * 
 * 
 * Note, the enhancement you get from using this widget with two selects
 * is not that great, but if you chain three or more selects you can see
 * the benefit, and that is the intended purpose of this widget.
 * 
 * 
 * See also http://docs.jquery.com/UI_Developer_Guide#The_widget_factory
 * 
 */
(function($){
	
	$.widget("ui.sequentialSelect", {
		
		options: {
			parent: null,
			optgroupAttr: 'for',
			
			// events
			optionsChange: function(){}
		},
		
		// a hidden select to store our filtered options
		storage: null,
		onChangeHandler: null,
		
		
		
		_create: function() {
			this._storeInitialValue();
			this._initStorage();
			this._createHandler();
			this._bindChainListeners();
			this.onChangeHandler.call(this.options.parent);
			this._restoreInitialValue();
		},
		
		_storeInitialValue: function(){
			this._initValue = this.element.val();
		},
		_restoreInitialValue: function(){
			this.element.val(this._initValue);
		},
		
		_initStorage: function(){
			// create hidden select
			this.storage = $('<select style="display:none" class="ui-sequential-select-storage"></select>');
			this.element.after(this.storage);
			// prepare options for storage - add unique identifier
			var count = 0;
			this.element.find('option').each(function(){
				$(this).attr('ui-sequential-select-id', count);
				count++;
			});
			// move options to storage
			this.storage.append(this.element.children()).data('storageFor', this.element);
		},
		
		
		_createHandler: function(){
			// defines the function which can be bound to and unbound from event listeners
			var self = this;
			this.onChangeHandler = function(){
				// rebuild my select and announce that my options have changed
				var val = $(this).val();
				if(val === null){
					val = $(this).find('option:first').val();
				}
				
				self._filter(val);
			};
		},
		
		
		/**
		 * @param unbindFrom - optional - unbind preexisting listener from this/these element
		 */
		_bindChainListeners: function(unbindFrom){
			if(unbindFrom) unbindFrom.unbind('change', this.onChangeHandler);
			this.options.parent.bind('change', this.onChangeHandler);
		},
		
				
		_filter: function(parentVal){
			if(!parentVal) return;
			
			// remember selected option
			var childValBefore = this.element.val();
			
			// move currently showing options back to storage, overwriting any existing options with same value
			var self = this;
			this.element.find('option').each(function(){
				self.storage.find('option[ui-sequential-select-id='+$(this).attr('ui-sequential-select-id')+']')
								.replaceWith(this);
			});
			
			// get options we need from storage
			var optgroup = this.storage.children('optgroup['+this.options.optgroupAttr+'='+parentVal+']');
			if(optgroup.size() < 1) return;
			optgroup.children().each(function(){
				$(this).clone().appendTo(self.element);
			});
						
			// reselect child option if possible (selection may have been lost by DOM modifications)
			var childValAfter = this.element.val();
			if(this.element.find('option[value="'+childValBefore+'"]').size() == 0){
				// gone, alert change
				this.element.change();
			}else if(childValBefore != childValAfter){
				this.element.val(childValBefore);
			}
			
			// trigger sequentialSelectOptionsChange
			this._trigger('optionsChange');
		},
		
		/**
		 * Get the select containing all options
		 */
		getStorage: function(){
			return this.storage;
		},
		
		/**
		 * Replace the current options with the ones from storage
		 */
		updateFromStorage: function(){
			var self = this;
			
			// remember selected child option
			var childValBefore = this.element.val();
			
			this.element.find('option').each(function(){
				var inStorage = self.storage.find('option[ui-sequential-select-id='+$(this).attr('ui-sequential-select-id')+']');
				var copyFromStorage = inStorage.clone();
				$(this).replaceWith(copyFromStorage);
			});
			
			// reselect child option
			this.element.val(childValBefore);
			
			// changed
			this._trigger('optionsChange');
		},
		
		
		_setOption: function(option, value){			
			// Re-bind and re-filter on change parent 
			if(option == 'parent'){
				var previousParent = this.options.parent;
				$.Widget.prototype._setOption.apply( this, arguments );  
				this._bindChainListeners(previousParent);
				this._filter(this.options.parent.val());
			}
		}
		
	});
	
})(jQuery);
